(() => {
  'use strict';

  if (window.CMDPermanentVariantDrawerLoaded) return;
  window.CMDPermanentVariantDrawerLoaded = true;

  const VERSION = '7.5.0-complete';
  const OPEN_CLASS = 'cmd-drawer-shell--open';
  const FINDER_OPEN_CLASS = 'cmd-size-finder--open';
  const CHART_OPEN_CLASS = 'cmd-size-chart-panel--open';
  const TRANSITION_MS = 230;
  const STATES = new Map();
  const FOCUSABLE_SELECTOR = [
    'button:not([disabled])',
    '[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');
  function normalizeColor(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[._\s]+/g, '-')
      .replace(/-+/g, '-');
  }

  function containsAny(value, terms) {
    return terms.some((term) => value.includes(term));
  }

  function getColorBackground(rawValue) {
    const value = normalizeColor(rawValue);

    if (
      containsAny(value, [
        'assorted',
        'ass-col',
        'ass_col',
        'asst',
        'pattern',
        'patt-',
      ])
    ) {
      return 'conic-gradient(#18243c 0 25%, #a8272f 0 50%, #c3b091 0 75%, #4f6f52 0)';
    }

    if (
      containsAny(value, [
        'blk/wht',
        'black/white',
        'black-and-white',
        'pepita',
      ])
    ) {
      return 'linear-gradient(135deg, #111 0 50%, #fff 50% 100%)';
    }

    if (containsAny(value, ['brn/blk', 'brown/black'])) {
      return 'linear-gradient(135deg, #6f4e37 0 50%, #111 50% 100%)';
    }

    if (containsAny(value, ['char/blk', 'charcoal/black'])) {
      return 'linear-gradient(135deg, #44464a 0 50%, #111 50% 100%)';
    }

    if (containsAny(value, ['gold/blk', 'gold/black'])) {
      return 'linear-gradient(135deg, #b38a36 0 50%, #111 50% 100%)';
    }

    if (
      containsAny(value, [
        'dmpq',
        'dbsp',
        'wfl',
        'jqrd',
        'stsp',
        's-flow',
      ])
    ) {
      return 'repeating-linear-gradient(135deg, #59616e 0 5px, #d8d2c8 5px 10px)';
    }

    if (
      value === 'black' ||
      value === 'blk' ||
      value.startsWith('black-') ||
      value.startsWith('blk-')
    ) {
      return '#111111';
    }

    if (
      containsAny(value, [
        'off-white',
        'off-wht',
        'ivory',
        'ivor',
        'ecru',
        'cream',
        'crm',
        'natural',
        'nat',
      ])
    ) {
      return '#f2ead8';
    }

    if (
      value === 'white' ||
      value === 'wht' ||
      value === 'whit' ||
      value === 'whtl' ||
      value.startsWith('white-') ||
      value.startsWith('wht-')
    ) {
      return '#ffffff';
    }

    if (
      value === 'navy' ||
      value === 'nvy' ||
      value.startsWith('navy-') ||
      value.startsWith('nvy-') ||
      value.includes('navy-blue')
    ) {
      return '#18243c';
    }

    if (
      containsAny(value, [
        'charcoal',
        'char',
        'ht-char',
        'h-char',
      ])
    ) {
      return '#44464a';
    }

    if (
      containsAny(value, [
        'light-grey',
        'light-gray',
        'lt-grey',
        'lt-gray',
        'ltgr',
        'lgry',
        'lt-grey',
      ])
    ) {
      return '#c9c9c7';
    }

    if (containsAny(value, ['silver', 'silv', 'svgr'])) {
      return '#bfc2c5';
    }

    if (containsAny(value, ['slate', 'slat'])) {
      return '#707982';
    }

    if (
      value === 'grey' ||
      value === 'gray' ||
      value.startsWith('grey-') ||
      value.startsWith('gray-') ||
      containsAny(value, ['h-grey', 'hd-grey'])
    ) {
      return '#858789';
    }

    if (
      containsAny(value, [
        'light-blue',
        'lt-blue',
        'lt-blu',
        'ltblu',
        'ltbl',
        'lt-blue',
        'lt_blu',
        'h-blue',
        's-blue',
        'sblue',
        'sblu',
        'sky-blue',
      ])
    ) {
      return '#a9cbe2';
    }

    if (
      containsAny(value, [
        'medium-blue',
        'med-blue',
        'med-blu',
        'medblu',
        'med_blu',
        'm-blue',
      ])
    ) {
      return '#4d78a2';
    }

    if (containsAny(value, ['royal', 'royl', 'ryl'])) {
      return '#244e9c';
    }

    if (containsAny(value, ['french-blue', 'fr-blue', 'fr-blu', 'fr_b', 'fr-bl'])) {
      return '#3b6e9f';
    }

    if (containsAny(value, ['ocean-blue', 'ocnblu'])) {
      return '#2d7187';
    }

    if (containsAny(value, ['denim'])) {
      return '#4d6f8c';
    }

    if (
      value === 'blue' ||
      value.startsWith('blue-') ||
      containsAny(value, ['n-blue', 'p-blue', 'pmblu', 'fblu', 'cel'])
    ) {
      return '#426f9e';
    }

    if (containsAny(value, ['aqua'])) {
      return '#69c7ca';
    }

    if (containsAny(value, ['turquoise', 'turq'])) {
      return '#36aaa7';
    }

    if (containsAny(value, ['teal'])) {
      return '#287b7a';
    }

    if (containsAny(value, ['olive', 'olv', 'o-olv', 'h-olv', 'n-olv'])) {
      return '#697153';
    }

    if (containsAny(value, ['hunter', 'hunt', 'hntgrn'])) {
      return '#35533d';
    }

    if (containsAny(value, ['forest', 'for-'])) {
      return '#365844';
    }

    if (containsAny(value, ['spruce', 'spruc'])) {
      return '#3f5d50';
    }

    if (containsAny(value, ['loden'])) {
      return '#58684b';
    }

    if (containsAny(value, ['lime'])) {
      return '#8fbf45';
    }

    if (containsAny(value, ['mint', 'lmgn', 'lmgrn', 'lgrn', 'mgrn'])) {
      return '#75a879';
    }

    if (
      value === 'green' ||
      value === 'grn' ||
      value.startsWith('green-') ||
      value.startsWith('grn-')
    ) {
      return '#4f7657';
    }

    if (containsAny(value, ['burgundy', 'burg'])) {
      return '#6d1f2b';
    }

    if (containsAny(value, ['wine'])) {
      return '#6a2639';
    }

    if (containsAny(value, ['raspberry', 'rsbry', 'berry', 'berr'])) {
      return '#9b3152';
    }

    if (
      value === 'red' ||
      value.startsWith('red-')
    ) {
      return '#a8272f';
    }

    if (containsAny(value, ['rose'])) {
      return '#c97986';
    }

    if (containsAny(value, ['pink'])) {
      return '#dda4b6';
    }

    if (containsAny(value, ['coral'])) {
      return '#e98478';
    }

    if (containsAny(value, ['peach', 'pch', 'lt-pch'])) {
      return '#e8aa82';
    }

    if (containsAny(value, ['rust'])) {
      return '#a45332';
    }

    if (containsAny(value, ['copper', 'copp'])) {
      return '#a86b43';
    }

    if (containsAny(value, ['orange', 'orng', 'ora', 'tang'])) {
      return '#d97932';
    }

    if (containsAny(value, ['gold'])) {
      return '#b38a36';
    }

    if (containsAny(value, ['honey', 'hony'])) {
      return '#c99c4d';
    }

    if (containsAny(value, ['mustard', 'must'])) {
      return '#b8942f';
    }

    if (containsAny(value, ['maize', 'maiz', 'banana', 'bana', 'butt'])) {
      return '#e2c765';
    }

    if (containsAny(value, ['yellow', 'yell', 'yel', 'dk-yel', 'lt-yel'])) {
      return '#d7bd3f';
    }

    if (containsAny(value, ['lavender', 'laven', 'lav-'])) {
      return '#b5a3cf';
    }

    if (containsAny(value, ['plum'])) {
      return '#70455f';
    }

    if (containsAny(value, ['mauve', 'mau'])) {
      return '#a37b91';
    }

    if (containsAny(value, ['purple', 'purp', 'prpl'])) {
      return '#69477d';
    }

    if (containsAny(value, ['chocolate', 'choc'])) {
      return '#5e3b2c';
    }

    if (containsAny(value, ['coffee', 'coff'])) {
      return '#6a4b3a';
    }

    if (containsAny(value, ['toast', 'toas'])) {
      return '#a67b55';
    }

    if (containsAny(value, ['bronze', 'brnz', 'bron'])) {
      return '#8e633e';
    }

    if (
      value === 'brown' ||
      value === 'brn' ||
      value.startsWith('brown-') ||
      value.startsWith('brn-') ||
      containsAny(value, ['h-brn', 'ht-brown'])
    ) {
      return '#6f4e37';
    }

    if (containsAny(value, ['camel', 'cam-']) || value === 'cam') {
      return '#b58d5e';
    }

    if (containsAny(value, ['taupe', 'taup'])) {
      return '#9b8979';
    }

    if (containsAny(value, ['khaki', 'khak'])) {
      return '#bca982';
    }

    if (
      value === 'tan' ||
      value.startsWith('tan-') ||
      containsAny(value, ['h-tan'])
    ) {
      return '#c19a6b';
    }

    if (containsAny(value, ['sand', 'snd'])) {
      return '#d1b995';
    }

    if (containsAny(value, ['stone', 'stn'])) {
      return '#aaa193';
    }

    if (containsAny(value, ['beige', 'bei'])) {
      return '#d4c2a8';
    }

    if (containsAny(value, ['mushroom', 'mush'])) {
      return '#9d8f82';
    }

    if (containsAny(value, ['tobacco', 'tbco'])) {
      return '#8b5c3b';
    }

    return null;
  }

  function applyColorSwatches(root = document) {
    const swatches = [];

    if (root.matches?.('.cmd-color-square[data-color-value]')) swatches.push(root);
    root.querySelectorAll?.('.cmd-color-square[data-color-value]').forEach((node) => swatches.push(node));

    swatches.forEach((swatch) => {
      if (swatch.dataset.shopifySwatch === 'true') {
        swatch.dataset.colorReady = 'true';
        return;
      }

      const background = getColorBackground(swatch.dataset.colorValue);
      if (background) {
        swatch.style.background = background;
        swatch.classList.remove('cmd-color-square--unknown');
      } else {
        swatch.style.removeProperty('background');
        swatch.classList.add('cmd-color-square--unknown');
      }
      swatch.dataset.colorReady = 'true';
    });
  }

  function escapeSelector(value) {
    if (window.CSS?.escape) return CSS.escape(String(value));
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function formatFraction(value) {
    return String(value ?? '')
      .trim()
      .replace(/\s*1\/2\b/g, '½')
      .replace(/\.5\b/g, '½');
  }

  function formatSleeveDate(value) {
    const months = {
      jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6,
      jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12,
    };
    const match = String(value ?? '').trim().match(/^(\d{1,2})[-\s](Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)$/i);
    if (!match) return null;

    const day = Number(match[1]);
    const month = months[match[2].toLowerCase()];
    if (!month || day < 1 || day > 11) return null;
    return `${month + 30}/${day + 30}`;
  }

  function formatOptionValue(value, optionName = '') {
    const name = String(optionName).toLowerCase();
    if (name.includes('sleeve')) {
      const repaired = formatSleeveDate(value);
      if (repaired) return repaired;
    }
    return formatFraction(value);
  }

  function parsePantSize(value) {
    const raw = String(value ?? '')
      .replace(/×/g, 'x')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();

    /* Classic Mens Direct warehouse length codes, for example 34 BLK-M. */
    const warehouseMatch = raw.match(/^(\d{2})(?:\s+.*?)?-(XXXXS|XXXS|XXS|XS|S|M|L)$/i);
    if (warehouseMatch) {
      const lengthMap = { L: 34, M: 32, S: 30, XS: 29, XXS: 28, XXXS: 27, XXXXS: 26 };
      const waist = Number(warehouseMatch[1]);
      const inseam = lengthMap[warehouseMatch[2].toUpperCase()];
      if (waist >= 24 && waist <= 70 && inseam) {
        return {
          waist: String(waist),
          inseam: String(inseam),
          label: `${waist}W × ${inseam}L`,
        };
      }
    }

    const patterns = [
      /^(\d{2})\s*W?\s*[xX]\s*(\d{2})\s*L?$/i,
      /^(\d{2})\s*W?\s*\/\s*(\d{2})\s*L?$/i,
      /^(\d{2})\s*W?\s*-\s*(\d{2})\s*L?$/i,
    ];

    let match = null;
    for (const pattern of patterns) {
      match = raw.match(pattern);
      if (match) break;
    }
    if (!match) return null;

    const waist = Number(match[1]);
    const inseam = Number(match[2]);
    if (waist < 24 || waist > 70 || inseam < 24 || inseam > 42) return null;

    return {
      waist: String(waist),
      inseam: String(inseam),
      label: `${waist}W × ${inseam}L`,
    };
  }

  function isUnavailable(input) {
    return input.disabled || input.classList.contains('disabled') || input.getAttribute('aria-disabled') === 'true';
  }

  function getSectionId(node) {
    return node?.dataset?.section || node?.getAttribute?.('data-section') || '';
  }

  function collectVariantSelects(root = document) {
    const nodes = [];
    if (root.matches?.('variant-selects.cmd-variant-selector')) nodes.push(root);
    root.querySelectorAll?.('variant-selects.cmd-variant-selector').forEach((node) => nodes.push(node));
    return nodes;
  }

  function chooseLiveVariantSelects(sectionId) {
    const candidates = Array.from(document.querySelectorAll(
      `variant-selects.cmd-variant-selector[data-section="${escapeSelector(sectionId)}"]`
    ));
    if (!candidates.length) return null;

    const connected = candidates.filter((node) => node.isConnected);
    const visible = connected.filter((node) => {
      const style = window.getComputedStyle(node);
      return style.display !== 'none'
        && style.visibility !== 'hidden'
        && !node.closest('[hidden]')
        && node.getClientRects().length > 0;
    });
    return visible.at(-1) || connected.at(-1) || candidates.at(-1);
  }

  function getPicker(variantSelects) {
    return variantSelects?.querySelector('[data-cmd-picker]') || null;
  }

  function getGroups(state) {
    const variantSelects = chooseLiveVariantSelects(state.sectionId) || state.variantSelects;
    if (!variantSelects) return [];
    state.variantSelects = variantSelects;

    return Array.from(variantSelects.querySelectorAll('[data-cmd-option-group]'))
      .sort((a, b) => Number(a.dataset.optionPosition || 0) - Number(b.dataset.optionPosition || 0))
      .map((fieldset, index) => {
        const optionName = fieldset.dataset.optionName || `Option ${index + 1}`;
        const position = Number(fieldset.dataset.optionPosition || index + 1);
        const entries = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map((input) => {
          const valueId = input.dataset.optionValueId || '';
          return {
            input,
            position,
            optionName,
            valueId,
            value: input.value,
            displayValue: formatOptionValue(input.value, optionName),
            selected: input.checked,
            unavailable: isUnavailable(input),
            pant: parsePantSize(input.value),
            key: `${position}:${valueId || input.value}`,
          };
        });
        return { fieldset, index, optionName, position, entries };
      });
  }

  function isCombinedPantPicker(groups) {
    return groups.length === 1 && groups[0].entries.length > 1 && groups[0].entries.every((entry) => entry.pant);
  }

  function looksLikeNeckGroup(group, groups) {
    if (groups.length < 2) return false;
    const name = group.optionName.toLowerCase();
    if (name.includes('neck') || name.includes('collar')) return true;
    if (!name.includes('size')) return false;

    const values = group.entries.map((entry) => Number(
      String(entry.value).replace('½', '.5').replace(/\s*1\/2/g, '.5')
    ));
    const valid = values.filter((value) => Number.isFinite(value) && value >= 13 && value <= 25);
    return valid.length >= Math.max(2, Math.ceil(values.length * 0.6));
  }

  function stepLabel(group, groups) {
    const name = group.optionName.toLowerCase();
    if (looksLikeNeckGroup(group, groups)) return 'Neck Size';
    if (name.includes('sleeve')) return 'Sleeve Length';
    if (name.includes('waist')) return 'Waist';
    if (name.includes('inseam')) return 'Inseam';
    if (name.includes('length') && groups.some((item) => item.optionName.toLowerCase().includes('waist'))) return 'Inseam';
    if (name.includes('fit')) return 'Fit';
    return group.optionName;
  }

  function unique(values) {
    return [...new Set(values)];
  }

  function selectedSummary(state, groups = getGroups(state)) {
    if (isCombinedPantPicker(groups)) {
      const selected = groups[0].entries.find((entry) => entry.selected);
      if (state.partialPantSelection && state.selectedWaist) return `${state.selectedWaist}W × —`;
      return selected?.pant?.label || 'Choose size';
    }

    const selected = groups
      .map((group) => group.entries.find((entry) => entry.selected))
      .filter(Boolean)
      .map((entry) => entry.displayValue);
    return selected.length ? selected.join(' × ') : 'Choose size';
  }

  function updateSelectedDisplays(state, text) {
    const variantSelects = chooseLiveVariantSelects(state.sectionId) || state.variantSelects;
    variantSelects?.querySelectorAll('[data-cmd-selected-value]').forEach((node) => {
      if (node.textContent !== text) node.textContent = text;
    });
    state.drawer.querySelectorAll('[data-cmd-selected-value]').forEach((node) => {
      if (node.textContent !== text) node.textContent = text;
    });
  }

  function createStep(index, title, note = '') {
    const section = document.createElement('section');
    section.className = 'cmd-drawer-step';
    section.dataset.stepIndex = String(index);

    const heading = document.createElement('h3');
    heading.className = 'cmd-drawer-step-title';
    heading.textContent = `${index + 1}. Select ${title}`;
    section.appendChild(heading);

    if (note) {
      const description = document.createElement('p');
      description.className = 'cmd-drawer-step-note';
      description.textContent = note;
      section.appendChild(description);
    }

    const grid = document.createElement('div');
    grid.className = 'cmd-choice-grid';
    section.appendChild(grid);
    return { section, grid };
  }

  function createChoiceButton({ text, selected = false, disabled = false, action, key }) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cmd-choice-button';
    button.textContent = text;
    button.disabled = disabled;
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    if (action) button.dataset.cmdAction = action;
    if (key) button.dataset.cmdKey = key;
    return button;
  }

  function renderCombinedPants(state, content, group) {
    const selectedEntry = group.entries.find((entry) => entry.selected);
    const availableWaists = unique(group.entries.filter((entry) => !entry.unavailable).map((entry) => entry.pant.waist));

    if (!state.selectedWaist || !group.entries.some((entry) => entry.pant.waist === state.selectedWaist)) {
      state.selectedWaist = selectedEntry?.pant?.waist || availableWaists[0] || group.entries[0]?.pant?.waist || '';
      state.partialPantSelection = false;
    }

    const waistStep = createStep(0, 'Waist');
    unique(group.entries.map((entry) => entry.pant.waist)).forEach((waist) => {
      const options = group.entries.filter((entry) => entry.pant.waist === waist);
      const button = createChoiceButton({
        text: waist,
        selected: waist === state.selectedWaist,
        disabled: !options.some((entry) => !entry.unavailable),
        action: 'waist',
        key: waist,
      });
      button.dataset.waist = waist;
      waistStep.grid.appendChild(button);
    });
    content.appendChild(waistStep.section);

    const inseamStep = createStep(1, 'Inseam', state.selectedWaist ? `Available lengths for ${state.selectedWaist}W` : 'Select a waist first');
    const matching = group.entries.filter((entry) => entry.pant.waist === state.selectedWaist);
    unique(matching.map((entry) => entry.pant.inseam)).forEach((inseam) => {
      const entry = matching.find((item) => item.pant.inseam === inseam);
      const selected = Boolean(entry?.selected && !state.partialPantSelection);
      const button = createChoiceButton({
        text: inseam,
        selected,
        disabled: !entry || entry.unavailable,
        action: 'native',
        key: entry?.key,
      });
      if (entry) {
        button.dataset.optionPosition = String(entry.position);
        button.dataset.optionValueId = entry.valueId;
        button.dataset.optionValue = entry.value;
      }
      inseamStep.grid.appendChild(button);
    });
    content.appendChild(inseamStep.section);
  }

  function renderGroupedOptions(state, content, groups) {
    groups.forEach((group, groupIndex) => {
      const step = createStep(groupIndex, stepLabel(group, groups));
      group.entries.forEach((entry) => {
        const button = createChoiceButton({
          text: entry.displayValue,
          selected: entry.selected,
          disabled: entry.unavailable,
          action: 'native',
          key: entry.key,
        });
        button.dataset.optionPosition = String(entry.position);
        button.dataset.optionValueId = entry.valueId;
        button.dataset.optionValue = entry.value;
        step.grid.appendChild(button);
      });
      content.appendChild(step.section);
    });
  }

  function renderSignature(groups, state) {
    const groupSignature = groups.map((group) => [
      group.position,
      group.optionName,
      group.entries.map((entry) => `${entry.valueId}|${entry.value}|${entry.selected ? 1 : 0}|${entry.unavailable ? 1 : 0}`).join(','),
    ].join(':')).join('||');
    return `${groupSignature}::${state.selectedWaist || ''}::${state.partialPantSelection ? 1 : 0}`;
  }

  function renderDrawer(state, { force = false } = {}) {
    const content = state.drawer.querySelector('[data-cmd-content]');
    if (!content) return;

    const groups = getGroups(state);
    const signature = renderSignature(groups, state);
    if (!force && signature === state.renderSignature) {
      updateSelectedDisplays(state, selectedSummary(state, groups));
      syncAddButton(state);
      syncQuantity(state);
      return;
    }

    const scrollTop = content.scrollTop;
    const scrollLeft = content.scrollLeft;
    const activeKey = state.pendingFocusKey || document.activeElement?.dataset?.cmdKey || '';
    const fragment = document.createDocumentFragment();

    if (isCombinedPantPicker(groups)) {
      renderCombinedPants(state, fragment, groups[0]);
    } else {
      state.partialPantSelection = false;
      renderGroupedOptions(state, fragment, groups);
    }

    content.replaceChildren(fragment);
    content.scrollTop = scrollTop;
    content.scrollLeft = scrollLeft;
    state.renderSignature = renderSignature(groups, state);

    updateSelectedDisplays(state, selectedSummary(state, groups));
    syncAddButton(state);
    syncQuantity(state);

    requestAnimationFrame(() => {
      content.scrollTop = scrollTop;
      content.scrollLeft = scrollLeft;
      if (activeKey) {
        state.drawer.querySelector(`[data-cmd-key="${escapeSelector(activeKey)}"]`)?.focus({ preventScroll: true });
      }
      state.pendingFocusKey = '';
    });
  }

  function getSelectedVariant(state) {
    const variantSelects = chooseLiveVariantSelects(state.sectionId) || state.variantSelects;
    const script = variantSelects?.querySelector('script[data-selected-variant]');
    if (!script?.textContent?.trim()) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('[CMD selector] Could not parse selected variant JSON.', error);
      return null;
    }
  }

  function getProductForm(state) {
    const formId = state.productFormId || state.drawer.dataset.productFormId;
    return formId ? document.getElementById(formId) : null;
  }

  function getMainAddButton(state) {
    const form = getProductForm(state);
    return form?.querySelector('button[name="add"], button[type="submit"]') || null;
  }

  function getMainQuantityInput(state) {
    const form = getProductForm(state);
    const formId = state.productFormId || state.drawer.dataset.productFormId || '';
    return form?.querySelector('input[name="quantity"]')
      || (formId
        ? document.querySelector(`input[name="quantity"][form="${escapeSelector(formId)}"]`)
        : null);
  }

  function getQuantityRules(input) {
    const min = Number.isFinite(Number(input?.min)) && input?.min !== '' ? Number(input.min) : 1;
    const max = Number.isFinite(Number(input?.max)) && input?.max !== '' ? Number(input.max) : Infinity;
    const step = Number.isFinite(Number(input?.step)) && Number(input.step) > 0 ? Number(input.step) : 1;
    return { min, max, step };
  }

  function normalizeQuantity(value, rules, fallback = 1) {
    let quantity = Number(value);
    if (!Number.isFinite(quantity)) quantity = Number(fallback);
    if (!Number.isFinite(quantity)) quantity = rules.min;
    quantity = Math.max(rules.min, Math.min(rules.max, quantity));
    quantity = rules.min + Math.round((quantity - rules.min) / rules.step) * rules.step;
    quantity = Math.max(rules.min, Math.min(rules.max, quantity));
    return Number(quantity.toFixed(6));
  }

  function syncQuantity(state) {
    const wrapper = state.drawer.querySelector('[data-cmd-quantity]');
    const drawerInput = state.drawer.querySelector('[data-cmd-quantity-input]');
    const minus = state.drawer.querySelector('[data-cmd-quantity-minus]');
    const plus = state.drawer.querySelector('[data-cmd-quantity-plus]');
    const mainInput = getMainQuantityInput(state);
    if (!wrapper || !drawerInput) return;

    wrapper.hidden = !mainInput;
    if (!mainInput) return;

    const rules = getQuantityRules(mainInput);
    const quantity = normalizeQuantity(mainInput.value, rules, rules.min);
    drawerInput.min = String(rules.min);
    drawerInput.step = String(rules.step);
    if (Number.isFinite(rules.max)) drawerInput.max = String(rules.max);
    else drawerInput.removeAttribute('max');
    if (document.activeElement !== drawerInput || drawerInput.value === '') {
      drawerInput.value = String(quantity);
    }
    if (minus) minus.disabled = quantity <= rules.min;
    if (plus) plus.disabled = Number.isFinite(rules.max) && quantity >= rules.max;
  }

  function setQuantity(state, value) {
    const mainInput = getMainQuantityInput(state);
    if (!mainInput) return;
    const rules = getQuantityRules(mainInput);
    const quantity = normalizeQuantity(value, rules, mainInput.value);
    mainInput.value = String(quantity);
    mainInput.dispatchEvent(new Event('input', { bubbles: true }));
    mainInput.dispatchEvent(new Event('change', { bubbles: true }));
    syncQuantity(state);
  }

  function adjustQuantity(state, direction) {
    const mainInput = getMainQuantityInput(state);
    if (!mainInput) return;
    const rules = getQuantityRules(mainInput);
    const current = normalizeQuantity(mainInput.value, rules, rules.min);
    setQuantity(state, current + direction * rules.step);
  }

  function syncAddButton(state) {
    const drawerButton = state.drawer.querySelector('[data-cmd-add-to-cart]');
    if (!drawerButton) return;

    const mainButton = getMainAddButton(state);
    const variant = getSelectedVariant(state);
    const label = mainButton?.querySelector('span')?.textContent?.trim()
      || mainButton?.textContent?.trim()
      || 'Add to cart';
    const labelNode = drawerButton.querySelector('[data-cmd-add-label]');
    if (labelNode) labelNode.textContent = label;

    const groups = getGroups(state);
    const partial = isCombinedPantPicker(groups) && state.partialPantSelection;
    drawerButton.disabled = partial || !mainButton || mainButton.disabled || !variant || variant.available === false;
  }

  let scrollLock = null;

  function lockPageScroll() {
    if (scrollLock) return;

    const body = document.body;
    const html = document.documentElement;
    const x = window.scrollX;
    const y = window.scrollY;
    const scrollbarWidth = Math.max(0, window.innerWidth - html.clientWidth);
    const computedPaddingRight = Number.parseFloat(window.getComputedStyle(body).paddingRight) || 0;

    scrollLock = {
      x,
      y,
      body: {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow,
        paddingRight: body.style.paddingRight,
      },
      html: {
        scrollBehavior: html.style.scrollBehavior,
        overscrollBehavior: html.style.overscrollBehavior,
      },
    };

    html.style.scrollBehavior = 'auto';
    html.style.overscrollBehavior = 'none';
    body.style.position = 'fixed';
    body.style.top = `-${y}px`;
    body.style.left = `-${x}px`;
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (scrollbarWidth) body.style.paddingRight = `${computedPaddingRight + scrollbarWidth}px`;
  }

  function unlockPageScroll() {
    if (!scrollLock) return;

    const body = document.body;
    const html = document.documentElement;
    const saved = scrollLock;
    scrollLock = null;

    Object.assign(body.style, saved.body);
    Object.assign(html.style, saved.html);
    window.scrollTo(saved.x, saved.y);
  }


  function getSizeFinder(state) {
    return state?.drawer?.querySelector('[data-cmd-size-finder]') || null;
  }

  function getSizeChart(state) {
    return state?.drawer?.querySelector('[data-cmd-size-chart-panel]') || null;
  }


  const ALPHA_SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2X', '3X', '4X', '5X', '6X', '7X', '8X'];
  const BOYS_SIZE_REFERENCES = [
    { size: 2, height: 34, weight: 29 },
    { size: 3, height: 37, weight: 33 },
    { size: 4, height: 40, weight: 38 },
    { size: 5, height: 43, weight: 43 },
    { size: 6, height: 46, weight: 49 },
    { size: 7, height: 49, weight: 56 },
    { size: 8, height: 52, weight: 64 },
    { size: 10, height: 55, weight: 74 },
    { size: 12, height: 58, weight: 88 },
    { size: 14, height: 61, weight: 105 },
    { size: 16, height: 64, weight: 123 },
    { size: 18, height: 67, weight: 142 },
    { size: 20, height: 70, weight: 160 },
    { size: 22, height: 72, weight: 180 },
  ];

  function normalizeSizeText(value) {
    return String(value ?? '')
      .trim()
      .toUpperCase()
      .replace(/½/g, '.5')
      .replace(/\s+1\/2\b/g, '.5')
      .replace(/×/g, 'X')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ');
  }

  function firstSizingNumber(value) {
    const match = normalizeSizeText(value).match(/\d+(?:\.5)?/);
    return match ? Number(match[0]) : null;
  }

  function parseUsualPantSize(value) {
    const normalized = normalizeSizeText(value);
    const match = normalized.match(/(?:^|\s)(\d{2})\s*W?\s*(?:X|\/|-)\s*(\d{2})\s*L?(?:\s|$)/);
    if (!match) return null;
    const waist = Number(match[1]);
    const inseam = Number(match[2]);
    if (waist < 24 || waist > 70 || inseam < 24 || inseam > 42) return null;
    return { waist, inseam };
  }

  function sleeveMidpoint(value) {
    const repaired = normalizeSizeText(formatOptionValue(value, 'Sleeve'));
    const range = repaired.match(/(\d{2})\s*[\/-]\s*(\d{2})/);
    if (range) {
      const first = Number(range[1]);
      const second = Number(range[2]);
      if (first >= 28 && second <= 45) return (first + second) / 2;
    }
    const single = repaired.match(/(?:^|\D)(\d{2})(?:\D|$)/);
    if (single) {
      const number = Number(single[1]);
      if (number >= 28 && number <= 45) return number;
    }
    return null;
  }

  function parseDressShirtSize(value) {
    const normalized = normalizeSizeText(value);
    const neckMatch = normalized.match(/(?:^|\s)(1[3-9]|2[0-5])(?:\.5)?/);
    const sleeveMatch = normalized.match(/(2[8-9]|3\d|4[0-5])\s*[\/-]\s*(2[8-9]|3\d|4[0-5])/);
    if (!neckMatch || !sleeveMatch) return null;

    const exactNeck = normalized.match(/(?:^|\s)((?:1[3-9]|2[0-5])(?:\.5)?)/);
    const neck = Number(exactNeck?.[1]);
    const first = Number(sleeveMatch[1]);
    const second = Number(sleeveMatch[2]);
    if (!Number.isFinite(neck) || first > second) return null;

    return {
      neck,
      sleeve: (first + second) / 2,
      label: `${formatFraction(String(neck))} × ${first}/${second}`,
    };
  }

  function normalizeAlphaSize(value) {
    let normalized = normalizeSizeText(value)
      .replace(/\bSIZE\b/g, '')
      .replace(/[\s_-]+/g, '')
      .replace(/EXTRALARGE/g, 'XL')
      .replace(/LARGE/g, 'L')
      .replace(/MEDIUM/g, 'M')
      .replace(/SMALL/g, 'S');

    const aliases = {
      XXSMALL: 'XXS', XSMALL: 'XS', SM: 'S', MED: 'M', LAR: 'L',
      XLARGE: 'XL', XXL: '2X', XXXL: '3X', XXXXL: '4X', XXXXXL: '5X',
    };
    if (aliases[normalized]) normalized = aliases[normalized];

    const numbered = normalized.match(/^(\d)(?:X|XL)$/);
    if (numbered) normalized = `${numbered[1]}X`;
    return ALPHA_SIZE_ORDER.includes(normalized) ? normalized : null;
  }

  function alphaRank(value) {
    const normalized = normalizeAlphaSize(value);
    return normalized ? ALPHA_SIZE_ORDER.indexOf(normalized) : null;
  }

  function availableEntries(group) {
    return group?.entries?.filter((entry) => !entry.unavailable) || [];
  }

  function sortedByScore(entries, score) {
    return entries
      .map((entry) => ({ entry, score: score(entry) }))
      .filter((item) => Number.isFinite(item.score))
      .sort((a, b) => a.score - b.score);
  }

  function looksLikeFitGroup(group) {
    const name = String(group?.optionName || '').toLowerCase();
    if (name.includes('fit')) return true;
    const values = group?.entries?.map((entry) => normalizeSizeText(entry.value).toLowerCase()) || [];
    const known = values.filter((value) => /(slim|skinny|regular|classic|relaxed|husky|modern|tailored|standard)/.test(value));
    return values.length > 1 && known.length >= Math.ceil(values.length * 0.6);
  }

  function fitEntryScore(entry, preference) {
    const value = normalizeSizeText(entry.value).toLowerCase();
    const groups = {
      close: ['slim', 'skinny', 'tailored', 'modern', 'close'],
      regular: ['regular', 'classic', 'standard', 'traditional'],
      relaxed: ['relaxed', 'husky', 'big', 'full', 'loose'],
    };
    const preferred = groups[preference] || groups.regular;
    const index = preferred.findIndex((term) => value.includes(term));
    if (index >= 0) return index;
    if (preference !== 'regular' && groups.regular.some((term) => value.includes(term))) return 10;
    return entry.selected ? 20 : 30;
  }

  function targetFromEntry(entry, metric, desired = {}) {
    return {
      position: entry.position,
      valueId: entry.valueId,
      value: entry.value,
      displayValue: entry.displayValue,
      metric,
      ...desired,
    };
  }

  function productFinderContext(state) {
    const variantSelects = chooseLiveVariantSelects(state.sectionId) || state.variantSelects;
    const title = String(variantSelects?.dataset?.productTitle || '').toLowerCase();
    const type = String(variantSelects?.dataset?.productType || '').toLowerCase();
    const vendor = String(variantSelects?.dataset?.productVendor || '').toLowerCase();
    return { title, type, vendor, combined: `${title} ${type} ${vendor}` };
  }

  function isCombinedShirtPicker(groups) {
    if (groups.length !== 1 || groups[0].entries.length < 2) return false;
    const parsed = groups[0].entries.filter((entry) => parseDressShirtSize(entry.value));
    return parsed.length >= Math.max(2, Math.ceil(groups[0].entries.length * 0.6));
  }

  function findSleeveGroup(groups) {
    return groups.find((group) => {
      const name = String(group.optionName || '').toLowerCase();
      if (name.includes('sleeve')) return true;
      const values = group.entries.map((entry) => sleeveMidpoint(entry.value)).filter(Number.isFinite);
      return group.entries.length > 1 && values.length >= Math.ceil(group.entries.length * 0.6);
    }) || null;
  }

  function findFitTarget(groups, preference) {
    const fitGroup = groups.find(looksLikeFitGroup);
    if (!fitGroup) return null;
    const scored = sortedByScore(availableEntries(fitGroup), (entry) => fitEntryScore(entry, preference));
    return scored[0]?.entry ? targetFromEntry(scored[0].entry, 'fit', { preference }) : null;
  }

  function recommendationReason(usedUsualSize, category) {
    if (usedUsualSize) {
      return `Based primarily on the size you usually wear, then matched to the available ${category} options for this item.`;
    }
    return `Estimated from your height, weight, and fit preference, then matched to the closest available ${category} option for this item.`;
  }

  function buildPantRecommendation(state, groups, answers) {
    const group = groups[0];
    const candidates = availableEntries(group).filter((entry) => entry.pant);
    if (!candidates.length) return { error: 'No available waist and inseam combinations were found for the currently selected color.' };

    const usual = parseUsualPantSize(answers.usualSize);
    let targetWaist = usual?.waist ?? (0.42 * answers.heightInches + 0.15 * answers.weight - 23);
    let targetInseam = usual?.inseam ?? (answers.heightInches - 38);

    if (answers.fit === 'close') targetWaist -= 1;
    if (answers.fit === 'relaxed') targetWaist += 1;
    targetWaist = Math.max(24, Math.min(70, targetWaist));
    targetInseam = Math.max(26, Math.min(38, targetInseam));

    const scored = sortedByScore(candidates, (entry) => (
      Math.abs(Number(entry.pant.waist) - targetWaist) * 3
      + Math.abs(Number(entry.pant.inseam) - targetInseam) * 1.25
    ));
    const best = scored[0]?.entry;
    if (!best) return { error: 'A matching pants size could not be calculated for this item.' };
    const alternate = scored.find((item) => item.entry.pant.label !== best.pant.label)?.entry || null;

    return {
      kind: 'pants',
      label: best.pant.label,
      alternateLabel: alternate?.pant?.label || '',
      reason: recommendationReason(Boolean(usual), 'pants'),
      targets: [targetFromEntry(best, 'pant', { targetWaist, targetInseam })],
    };
  }

  function buildGroupedPantRecommendation(groups, answers) {
    const waistGroup = groups.find((group) => String(group.optionName || '').toLowerCase().includes('waist'));
    const inseamGroup = groups.find((group) => {
      const name = String(group.optionName || '').toLowerCase();
      return name.includes('inseam')
        || (name.includes('length') && waistGroup && group !== waistGroup);
    });
    if (!waistGroup || !inseamGroup || waistGroup === inseamGroup) return null;

    const usual = parseUsualPantSize(answers.usualSize);
    let targetWaist = usual?.waist ?? (0.42 * answers.heightInches + 0.15 * answers.weight - 23);
    let targetInseam = usual?.inseam ?? (answers.heightInches - 38);
    if (answers.fit === 'close') targetWaist -= 1;
    if (answers.fit === 'relaxed') targetWaist += 1;
    targetWaist = Math.max(24, Math.min(70, targetWaist));
    targetInseam = Math.max(26, Math.min(38, targetInseam));

    const waistScored = sortedByScore(availableEntries(waistGroup), (entry) => {
      const number = firstSizingNumber(entry.value);
      return Number.isFinite(number) ? Math.abs(number - targetWaist) : Infinity;
    });
    const inseamScored = sortedByScore(availableEntries(inseamGroup), (entry) => {
      const number = firstSizingNumber(entry.value);
      return Number.isFinite(number) ? Math.abs(number - targetInseam) : Infinity;
    });
    const waist = waistScored[0]?.entry;
    const inseam = inseamScored[0]?.entry;
    if (!waist || !inseam) {
      return { error: 'No available waist and inseam combination could be matched for this item.' };
    }

    const waistNumber = firstSizingNumber(waist.value);
    const inseamNumber = firstSizingNumber(inseam.value);
    const fitTarget = findFitTarget(groups, answers.fit);
    const baseLabel = `${formatFraction(String(waistNumber))}W × ${formatFraction(String(inseamNumber))}L`;
    const label = fitTarget ? `${baseLabel} · ${fitTarget.displayValue}` : baseLabel;
    const targets = [
      targetFromEntry(waist, 'number', { targetNumber: targetWaist }),
      targetFromEntry(inseam, 'number', { targetNumber: targetInseam }),
    ];
    if (fitTarget) targets.push(fitTarget);

    const alternateWaist = waistScored[1]?.entry;
    const alternateInseam = inseamScored[1]?.entry;
    const alternateLabel = alternateWaist
      ? `${formatFraction(String(firstSizingNumber(alternateWaist.value)))}W × ${formatFraction(String(inseamNumber))}L`
      : alternateInseam
        ? `${formatFraction(String(waistNumber))}W × ${formatFraction(String(firstSizingNumber(alternateInseam.value)))}L`
        : '';

    return {
      kind: 'pants',
      label,
      alternateLabel,
      reason: recommendationReason(Boolean(usual), 'pants'),
      targets,
    };
  }

  function buildCombinedShirtRecommendation(groups, answers) {
    const group = groups[0];
    const candidates = availableEntries(group)
      .map((entry) => ({ entry, shirt: parseDressShirtSize(entry.value) }))
      .filter((item) => item.shirt);
    if (!candidates.length) return { error: 'No available neck and sleeve combinations were found for the currently selected color.' };

    const usual = parseDressShirtSize(answers.usualSize);
    let targetNeck = usual?.neck ?? (0.055 * answers.weight + 0.02 * answers.heightInches + 4.3);
    let targetSleeve = usual?.sleeve ?? (
      answers.heightInches <= 68 ? 32.5
        : answers.heightInches <= 72 ? 34.5
          : answers.heightInches <= 76 ? 36.5
            : answers.heightInches <= 79 ? 38.5 : 40.5
    );
    if (answers.fit === 'close') targetNeck -= 0.25;
    if (answers.fit === 'relaxed') targetNeck += 0.25;

    const scored = candidates
      .map((item) => ({
        ...item,
        score: Math.abs(item.shirt.neck - targetNeck) * 4 + Math.abs(item.shirt.sleeve - targetSleeve),
      }))
      .sort((a, b) => a.score - b.score);
    const best = scored[0];
    const alternate = scored.find((item) => item.shirt.label !== best.shirt.label) || null;

    return {
      kind: 'dress-shirt',
      label: best.shirt.label,
      alternateLabel: alternate?.shirt?.label || '',
      reason: recommendationReason(Boolean(usual), 'dress-shirt'),
      targets: [targetFromEntry(best.entry, 'combined-shirt', { targetNeck, targetSleeve })],
    };
  }

  function buildGroupedShirtRecommendation(groups, answers) {
    const neckGroup = groups.find((group) => looksLikeNeckGroup(group, groups));
    const sleeveGroup = findSleeveGroup(groups);
    if (!neckGroup || !sleeveGroup || neckGroup === sleeveGroup) return null;

    const usual = parseDressShirtSize(answers.usualSize);
    let targetNeck = usual?.neck ?? (0.055 * answers.weight + 0.02 * answers.heightInches + 4.3);
    let targetSleeve = usual?.sleeve ?? (
      answers.heightInches <= 68 ? 32.5
        : answers.heightInches <= 72 ? 34.5
          : answers.heightInches <= 76 ? 36.5
            : answers.heightInches <= 79 ? 38.5 : 40.5
    );
    if (answers.fit === 'close') targetNeck -= 0.25;
    if (answers.fit === 'relaxed') targetNeck += 0.25;

    const neckScored = sortedByScore(availableEntries(neckGroup), (entry) => {
      const number = firstSizingNumber(entry.value);
      return Number.isFinite(number) ? Math.abs(number - targetNeck) : Infinity;
    });
    const sleeveScored = sortedByScore(availableEntries(sleeveGroup), (entry) => {
      const number = sleeveMidpoint(entry.value);
      return Number.isFinite(number) ? Math.abs(number - targetSleeve) : Infinity;
    });
    const neck = neckScored[0]?.entry;
    const sleeve = sleeveScored[0]?.entry;
    if (!neck || !sleeve) return { error: 'No available neck and sleeve combination could be matched for this item.' };

    const fitTarget = findFitTarget(groups, answers.fit);
    const targets = [
      targetFromEntry(neck, 'number', { targetNumber: targetNeck }),
      targetFromEntry(sleeve, 'sleeve', { targetNumber: targetSleeve }),
    ];
    if (fitTarget) targets.push(fitTarget);

    const baseLabel = `${neck.displayValue} × ${sleeve.displayValue}`;
    const label = fitTarget ? `${baseLabel} · ${fitTarget.displayValue}` : baseLabel;
    const alternateNeck = neckScored[1]?.entry;
    const alternateSleeve = sleeveScored[1]?.entry;
    const alternateLabel = alternateNeck
      ? `${alternateNeck.displayValue} × ${sleeve.displayValue}`
      : alternateSleeve ? `${neck.displayValue} × ${alternateSleeve.displayValue}` : '';

    return {
      kind: 'dress-shirt',
      label,
      alternateLabel,
      reason: recommendationReason(Boolean(usual), 'dress-shirt'),
      targets,
    };
  }

  function estimateAlphaRank(height, weight) {
    let rank;
    if (weight <= 135) rank = ALPHA_SIZE_ORDER.indexOf('XS');
    else if (weight <= 155) rank = ALPHA_SIZE_ORDER.indexOf('S');
    else if (weight <= 180) rank = ALPHA_SIZE_ORDER.indexOf('M');
    else if (weight <= 205) rank = ALPHA_SIZE_ORDER.indexOf('L');
    else if (weight <= 235) rank = ALPHA_SIZE_ORDER.indexOf('XL');
    else if (weight <= 270) rank = ALPHA_SIZE_ORDER.indexOf('2X');
    else if (weight <= 305) rank = ALPHA_SIZE_ORDER.indexOf('3X');
    else if (weight <= 345) rank = ALPHA_SIZE_ORDER.indexOf('4X');
    else if (weight <= 385) rank = ALPHA_SIZE_ORDER.indexOf('5X');
    else rank = ALPHA_SIZE_ORDER.indexOf('6X');
    if (height >= 76 && weight >= 170) rank += 1;
    return Math.max(0, Math.min(ALPHA_SIZE_ORDER.length - 1, rank));
  }

  function buildAlphaRecommendation(groups, answers) {
    const sizeGroup = groups.find((group) => {
      if (looksLikeFitGroup(group)) return false;
      const parsed = group.entries.filter((entry) => alphaRank(entry.value) !== null);
      return parsed.length >= Math.max(2, Math.ceil(group.entries.length * 0.6));
    });
    if (!sizeGroup) return null;

    const usualRank = alphaRank(answers.usualSize);
    let targetRank = usualRank ?? estimateAlphaRank(answers.heightInches, answers.weight);
    if (answers.fit === 'close') targetRank -= 1;
    if (answers.fit === 'relaxed') targetRank += 1;

    const scored = sortedByScore(availableEntries(sizeGroup), (entry) => {
      const rank = alphaRank(entry.value);
      return rank === null ? Infinity : Math.abs(rank - targetRank);
    });
    const best = scored[0]?.entry;
    if (!best) return { error: 'No available letter size could be matched for this item.' };
    const alternate = scored.find((item) => item.entry.value !== best.value)?.entry || null;
    const fitTarget = findFitTarget(groups, answers.fit);
    const targets = [targetFromEntry(best, 'alpha', { targetRank })];
    if (fitTarget) targets.push(fitTarget);

    return {
      kind: 'alpha',
      label: fitTarget ? `${best.displayValue} · ${fitTarget.displayValue}` : best.displayValue,
      alternateLabel: alternate?.displayValue || '',
      reason: recommendationReason(usualRank !== null, 'letter-size'),
      targets,
    };
  }

  function buildBoysRecommendation(groups, answers) {
    const sizeGroup = groups.find((group) => {
      if (looksLikeFitGroup(group)) return false;
      const values = group.entries.map((entry) => firstSizingNumber(entry.value)).filter(Number.isFinite);
      return values.length >= Math.max(2, Math.ceil(group.entries.length * 0.6))
        && Math.min(...values) <= 8 && Math.max(...values) <= 22;
    });
    if (!sizeGroup) return null;

    const usualNumber = firstSizingNumber(answers.usualSize);
    let targetSize = null;
    if (Number.isFinite(usualNumber) && usualNumber >= 2 && usualNumber <= 22) {
      targetSize = usualNumber;
    } else {
      const reference = BOYS_SIZE_REFERENCES
        .map((item) => ({
          item,
          score: Math.abs(item.height - answers.heightInches) * 2 + Math.abs(item.weight - answers.weight) / 8,
        }))
        .sort((a, b) => a.score - b.score)[0]?.item;
      targetSize = reference?.size ?? 10;
    }

    if (answers.fit === 'close') targetSize -= 1;
    if (answers.fit === 'relaxed') targetSize += 1;

    const scored = sortedByScore(availableEntries(sizeGroup), (entry) => {
      const number = firstSizingNumber(entry.value);
      return Number.isFinite(number) ? Math.abs(number - targetSize) : Infinity;
    });
    const best = scored[0]?.entry;
    if (!best) return { error: 'No available boys’ size could be matched for this item.' };
    const alternate = scored.find((item) => item.entry.value !== best.value)?.entry || null;
    const fitTarget = findFitTarget(groups, answers.fit);
    const targets = [targetFromEntry(best, 'number', { targetNumber: targetSize })];
    if (fitTarget) targets.push(fitTarget);

    return {
      kind: 'boys',
      label: fitTarget ? `${best.displayValue} · ${fitTarget.displayValue}` : best.displayValue,
      alternateLabel: alternate?.displayValue || '',
      reason: recommendationReason(Number.isFinite(usualNumber), 'boys’ size'),
      targets,
    };
  }

  function buildGenericRecommendation(groups, answers) {
    if (!answers.usualSize.trim()) {
      return { error: 'For this item, enter the size you usually wear so we can compare it with the available options.' };
    }

    const normalizedUsual = normalizeSizeText(answers.usualSize).replace(/\s/g, '');
    const sizeGroup = groups.find((group) => !looksLikeFitGroup(group));
    if (!sizeGroup) return { error: 'This item does not have a size option that the finder can compare.' };
    const candidates = availableEntries(sizeGroup);
    if (!candidates.length) return { error: 'No available sizes were found for the currently selected color.' };

    let best = candidates.find((entry) => {
      const normalizedValue = normalizeSizeText(entry.value).replace(/\s/g, '');
      return normalizedValue === normalizedUsual || normalizedUsual.includes(normalizedValue);
    });

    const targetNumber = firstSizingNumber(answers.usualSize);
    if (!best && Number.isFinite(targetNumber)) {
      best = sortedByScore(candidates, (entry) => {
        const number = firstSizingNumber(entry.value);
        return Number.isFinite(number) ? Math.abs(number - targetNumber) : Infinity;
      })[0]?.entry;
    }
    if (!best) return { error: 'We could not match that usual size to this item. Check the size wording and try again.' };

    const fitTarget = findFitTarget(groups, answers.fit);
    const targets = [targetFromEntry(best, Number.isFinite(targetNumber) ? 'number' : 'exact', { targetNumber })];
    if (fitTarget) targets.push(fitTarget);

    return {
      kind: 'generic',
      label: fitTarget ? `${best.displayValue} · ${fitTarget.displayValue}` : best.displayValue,
      alternateLabel: '',
      reason: 'Matched from the size you usually wear to the closest available option for this item.',
      targets,
    };
  }

  function recommendBestSize(state, answers) {
    const groups = getGroups(state);
    if (!groups.length) return { error: 'No size options were found for this item.' };

    if (isCombinedPantPicker(groups)) return buildPantRecommendation(state, groups, answers);
    const groupedPant = buildGroupedPantRecommendation(groups, answers);
    if (groupedPant) return groupedPant;
    if (isCombinedShirtPicker(groups)) return buildCombinedShirtRecommendation(groups, answers);

    const groupedShirt = buildGroupedShirtRecommendation(groups, answers);
    if (groupedShirt) return groupedShirt;

    const context = productFinderContext(state);
    const boysLikely = /(boy|boys|youth|kid|kids|junior)/.test(context.combined)
      || groups.some((group) => {
        const values = group.entries.map((entry) => firstSizingNumber(entry.value)).filter(Number.isFinite);
        return values.length >= 3 && Math.min(...values) <= 4 && Math.max(...values) <= 22;
      });
    if (boysLikely) {
      const boys = buildBoysRecommendation(groups, answers);
      if (boys) return boys;
    }

    const alpha = buildAlphaRecommendation(groups, answers);
    if (alpha) return alpha;
    return buildGenericRecommendation(groups, answers);
  }

  function finderForm(state) {
    return getSizeFinder(state)?.querySelector('[data-cmd-finder-form]') || null;
  }

  function clearFinderError(state) {
    const error = getSizeFinder(state)?.querySelector('[data-cmd-finder-error]');
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  }

  function showFinderError(state, message) {
    const error = getSizeFinder(state)?.querySelector('[data-cmd-finder-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    error.focus?.({ preventScroll: true });
  }

  function resetFinderView(state) {
    const finder = getSizeFinder(state);
    if (!finder) return;
    const form = finder.querySelector('[data-cmd-finder-form]');
    const result = finder.querySelector('[data-cmd-finder-result]');
    if (form) form.hidden = false;
    if (result) result.hidden = true;
    const apply = finder.querySelector('[data-cmd-finder-apply]');
    if (apply) {
      apply.disabled = false;
      apply.textContent = 'SELECT THIS SIZE';
      apply.removeAttribute('data-cmd-finder-apply-failed');
    }
    clearFinderError(state);
    state.finderRecommendation = null;
  }

  function readFinderAnswers(form) {
    const data = new FormData(form);
    const feet = Number(data.get('finder_height_feet'));
    const inches = Number(data.get('finder_height_inches'));
    const weight = Number(data.get('finder_weight'));
    return {
      heightInches: feet * 12 + inches,
      weight,
      usualSize: String(data.get('finder_usual_size') || '').trim(),
      fit: String(data.get('finder_fit') || 'regular'),
    };
  }

  function showFinderResult(state, recommendation) {
    const finder = getSizeFinder(state);
    if (!finder) return;
    const form = finder.querySelector('[data-cmd-finder-form]');
    const result = finder.querySelector('[data-cmd-finder-result]');
    if (!result) return;

    const size = result.querySelector('[data-cmd-finder-result-size]');
    const reason = result.querySelector('[data-cmd-finder-result-reason]');
    const alternate = result.querySelector('[data-cmd-finder-alternate]');
    const alternateSize = result.querySelector('[data-cmd-finder-alternate-size]');
    if (size) size.textContent = recommendation.label;
    if (reason) reason.textContent = recommendation.reason;
    if (alternate && alternateSize) {
      alternate.hidden = !recommendation.alternateLabel;
      alternateSize.textContent = recommendation.alternateLabel || '';
    }

    if (form) form.hidden = true;
    result.hidden = false;
    state.finderRecommendation = recommendation;
    const body = finder.querySelector('.cmd-size-finder-body');
    if (body) body.scrollTop = 0;
    requestAnimationFrame(() => size?.focus({ preventScroll: true }));
  }

  function editFinderAnswers(state) {
    const finder = getSizeFinder(state);
    if (!finder) return;
    const form = finder.querySelector('[data-cmd-finder-form]');
    const result = finder.querySelector('[data-cmd-finder-result]');
    if (result) result.hidden = true;
    if (form) {
      form.hidden = false;
      form.querySelector('select, input')?.focus({ preventScroll: true });
    }
    state.finderRecommendation = null;
  }

  function handleFinderSubmit(state, event) {
    const form = event.target.closest?.('[data-cmd-finder-form]');
    if (!form) return;
    event.preventDefault();
    clearFinderError(state);
    if (!form.reportValidity()) return;

    const answers = readFinderAnswers(form);
    if (!Number.isFinite(answers.heightInches) || answers.heightInches < 30 || answers.heightInches > 95) {
      showFinderError(state, 'Enter a valid height to continue.');
      return;
    }
    if (!Number.isFinite(answers.weight) || answers.weight < 20 || answers.weight > 500) {
      showFinderError(state, 'Enter a valid approximate weight to continue.');
      return;
    }

    const recommendation = recommendBestSize(state, answers);
    if (recommendation.error) {
      showFinderError(state, recommendation.error);
      return;
    }
    showFinderResult(state, recommendation);
  }

  function bestEntryForTarget(group, target) {
    const candidates = availableEntries(group);
    if (!candidates.length) return null;

    const exact = candidates.find((entry) => (
      (target.valueId && entry.valueId === target.valueId) || entry.value === target.value
    ));
    if (exact) return exact;

    const scored = sortedByScore(candidates, (entry) => {
      if (target.metric === 'pant') {
        return entry.pant
          ? Math.abs(Number(entry.pant.waist) - target.targetWaist) * 3
            + Math.abs(Number(entry.pant.inseam) - target.targetInseam) * 1.25
          : Infinity;
      }
      if (target.metric === 'combined-shirt') {
        const shirt = parseDressShirtSize(entry.value);
        return shirt
          ? Math.abs(shirt.neck - target.targetNeck) * 4 + Math.abs(shirt.sleeve - target.targetSleeve)
          : Infinity;
      }
      if (target.metric === 'alpha') {
        const rank = alphaRank(entry.value);
        return rank === null ? Infinity : Math.abs(rank - target.targetRank);
      }
      if (target.metric === 'fit') return fitEntryScore(entry, target.preference);
      if (target.metric === 'sleeve') {
        const number = sleeveMidpoint(entry.value);
        return Number.isFinite(number) ? Math.abs(number - target.targetNumber) : Infinity;
      }
      if (target.metric === 'number') {
        const number = firstSizingNumber(entry.value);
        return Number.isFinite(number) ? Math.abs(number - target.targetNumber) : Infinity;
      }
      return normalizeSizeText(entry.value) === normalizeSizeText(target.value) ? 0 : 100;
    });
    return scored[0]?.entry || null;
  }

  function waitForOptionRefresh(state, position, selectedValue, previousInput, timeout = 3200) {
    const started = Date.now();
    return new Promise((resolve) => {
      const check = () => {
        const elapsed = Date.now() - started;
        const groups = getGroups(state);
        const group = groups.find((item) => Number(item.position) === Number(position));
        const selected = group?.entries?.find((entry) => entry.selected);
        const selectedMatches = selected?.value === selectedValue;
        const refreshed = !previousInput?.isConnected;
        if (selectedMatches && (refreshed || elapsed >= 900)) {
          resolve(true);
          return;
        }
        if (elapsed >= timeout) {
          resolve(Boolean(selectedMatches));
          return;
        }
        window.setTimeout(check, 80);
      };
      window.setTimeout(check, 80);
    });
  }

  async function applyFinderRecommendation(state) {
    const recommendation = state.finderRecommendation;
    const finder = getSizeFinder(state);
    const button = finder?.querySelector('[data-cmd-finder-apply]');
    if (!recommendation?.targets?.length || !button || state.finderApplying) return;

    state.finderApplying = true;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'SELECTING SIZE…';

    try {
      const orderedTargets = [...recommendation.targets].sort((a, b) => Number(a.position) - Number(b.position));
      for (const target of orderedTargets) {
        const groups = getGroups(state);
        const group = groups.find((item) => Number(item.position) === Number(target.position));
        const entry = bestEntryForTarget(group, target);
        if (!entry) throw new Error(`No available option for ${target.displayValue || target.value}.`);
        if (entry.selected) continue;

        const previousInput = entry.input;
        state.partialPantSelection = false;
        entry.input.click();
        scheduleSync(state);
        await waitForOptionRefresh(state, entry.position, entry.value, previousInput);
        syncState(state);
      }

      syncState(state);
      button.textContent = 'SIZE SELECTED';
      window.setTimeout(() => closeSizeFinder(state, { restoreFocus: false }), 260);
    } catch (error) {
      console.warn('[CMD size finder] Could not apply the recommendation.', error);
      const resultReason = finder.querySelector('[data-cmd-finder-result-reason]');
      if (resultReason) {
        resultReason.textContent = 'That combination changed or is no longer available. Please select the closest size manually from the size options.';
      }
      button.textContent = 'RETURN TO SIZE OPTIONS';
      button.disabled = false;
      button.dataset.cmdFinderApplyFailed = 'true';
    } finally {
      state.finderApplying = false;
      if (!button.dataset.cmdFinderApplyFailed) {
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalLabel;
        }, 700);
      }
    }
  }

  function handleFinderFieldChange(state, event) {
    if (!event.target.closest?.('[data-cmd-finder-form]')) return;
    clearFinderError(state);
  }

  function setFinderUnderlayState(state, hidden) {
    if (!state?.drawer) return;
    [
      state.drawer.querySelector('.cmd-drawer-header'),
      state.drawer.querySelector('.cmd-drawer-content'),
      state.drawer.querySelector('.cmd-drawer-footer'),
    ].forEach((node) => {
      if (!node) return;
      node.inert = hidden;
      if (hidden) node.setAttribute('aria-hidden', 'true');
      else node.removeAttribute('aria-hidden');
    });
  }

  function openSizeFinder(state, trigger) {
    const finder = getSizeFinder(state);
    if (!finder) return;

    state.finderTrigger = trigger || state.drawer.querySelector('[data-cmd-find-size]') || null;
    resetFinderView(state);
    state.finderOpen = true;
    finder.hidden = false;
    finder.setAttribute('aria-hidden', 'false');
    state.finderTrigger?.setAttribute('aria-expanded', 'true');
    setFinderUnderlayState(state, true);

    requestAnimationFrame(() => {
      finder.classList.add(FINDER_OPEN_CLASS);
      requestAnimationFrame(() => {
        finder.querySelector('[data-cmd-finder-close]')?.focus({ preventScroll: true });
      });
    });
  }

  function closeSizeFinder(state, { restoreFocus = true, immediate = false } = {}) {
    const finder = getSizeFinder(state);
    if (!finder || !state?.finderOpen) return;

    state.finderOpen = false;
    finder.classList.remove(FINDER_OPEN_CLASS);
    finder.setAttribute('aria-hidden', 'true');
    state.finderTrigger?.setAttribute('aria-expanded', 'false');
    setFinderUnderlayState(state, Boolean(state.chartOpen));

    const finish = () => {
      if (!state.finderOpen) finder.hidden = true;
      if (restoreFocus && state.finderTrigger?.isConnected) {
        state.finderTrigger.focus({ preventScroll: true });
      }
    };

    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else window.setTimeout(finish, TRANSITION_MS);
  }

  function setChartUnderlayState(state, hidden) {
    const finder = getSizeFinder(state);

    if (state?.finderOpen && finder) {
      finder.inert = hidden;
      if (hidden) finder.setAttribute('aria-hidden', 'true');
      else finder.setAttribute('aria-hidden', 'false');
      return;
    }

    setFinderUnderlayState(state, hidden);
  }

  function openSizeChart(state, trigger) {
    const chart = getSizeChart(state);
    if (!chart) return;

    state.chartTrigger = trigger || state.drawer.querySelector('[data-cmd-size-chart]') || null;
    state.chartOpen = true;
    chart.hidden = false;
    chart.setAttribute('aria-hidden', 'false');
    state.drawer.querySelectorAll('[data-cmd-size-chart]').forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });
    setChartUnderlayState(state, true);

    requestAnimationFrame(() => {
      chart.classList.add(CHART_OPEN_CLASS);
      requestAnimationFrame(() => {
        chart.querySelector('[data-cmd-size-chart-close]')?.focus({ preventScroll: true });
      });
    });
  }

  function closeSizeChart(state, { restoreFocus = true, immediate = false } = {}) {
    const chart = getSizeChart(state);
    if (!chart || !state?.chartOpen) return;

    state.chartOpen = false;
    chart.classList.remove(CHART_OPEN_CLASS);
    chart.setAttribute('aria-hidden', 'true');
    state.drawer.querySelectorAll('[data-cmd-size-chart]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    setChartUnderlayState(state, false);

    const finish = () => {
      if (!state.chartOpen) chart.hidden = true;
      if (restoreFocus && state.chartTrigger?.isConnected) {
        state.chartTrigger.focus({ preventScroll: true });
      }
    };

    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else window.setTimeout(finish, TRANSITION_MS);
  }

  function openDrawer(state, trigger) {
    if (!state?.drawer) return;

    if (Array.from(STATES.values()).some((item) => item.isOpen && item !== state)) {
      Array.from(STATES.values()).forEach((item) => {
        if (item.isOpen && item !== state) closeDrawer(item, { restoreFocus: false, immediate: true });
      });
    }

    state.lastTrigger = trigger || state.trigger || null;
    state.isOpen = true;
    state.drawer.hidden = false;
    state.drawer.setAttribute('aria-hidden', 'false');
    state.trigger?.setAttribute('aria-expanded', 'true');
    renderDrawer(state, { force: true });
    lockPageScroll();

    requestAnimationFrame(() => {
      state.drawer.classList.add(OPEN_CLASS);
      requestAnimationFrame(() => {
        state.drawer.querySelector('[data-cmd-close-button]')?.focus({ preventScroll: true });
      });
    });
  }

  function closeDrawer(state, { restoreFocus = true, immediate = false } = {}) {
    if (!state?.drawer || !state.isOpen) return;

    if (state.chartOpen) {
      closeSizeChart(state, { restoreFocus: false, immediate: true });
    }

    if (state.finderOpen) {
      closeSizeFinder(state, { restoreFocus: false, immediate: true });
    }

    state.isOpen = false;
    state.drawer.classList.remove(OPEN_CLASS);
    state.drawer.setAttribute('aria-hidden', 'true');
    state.trigger?.setAttribute('aria-expanded', 'false');

    const finish = () => {
      if (!state.isOpen) state.drawer.hidden = true;
      if (![...STATES.values()].some((item) => item.isOpen)) unlockPageScroll();
      if (restoreFocus && state.lastTrigger?.isConnected) {
        state.lastTrigger.focus({ preventScroll: true });
      }
    };

    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else window.setTimeout(finish, TRANSITION_MS);
  }

  function trapFocus(state, event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (state.chartOpen) closeSizeChart(state);
      else if (state.finderOpen) closeSizeFinder(state);
      else closeDrawer(state);
      return;
    }
    if (event.key !== 'Tab') return;

    const scope = state.chartOpen ? getSizeChart(state) : (state.finderOpen ? getSizeFinder(state) : state.drawer);
    if (!scope) return;
    const focusable = Array.from(scope.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter((node) => !node.hidden
        && node.getAttribute('aria-hidden') !== 'true'
        && !node.closest('[hidden],[aria-hidden="true"]'));
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function resolveNativeInput(state, button) {
    const variantSelects = chooseLiveVariantSelects(state.sectionId) || state.variantSelects;
    if (!variantSelects) return null;

    const position = button.dataset.optionPosition;
    const valueId = button.dataset.optionValueId;
    const value = button.dataset.optionValue;
    const group = variantSelects.querySelector(`[data-cmd-option-group][data-option-position="${escapeSelector(position)}"]`);
    if (!group) return null;

    if (valueId) {
      const byId = group.querySelector(`input[data-option-value-id="${escapeSelector(valueId)}"]`);
      if (byId) return byId;
    }

    return Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => input.value === value) || null;
  }

  function scheduleSync(state) {
    clearTimeout(state.syncTimer);
    state.syncTimer = window.setTimeout(() => syncState(state), 0);
  }

  function selectNativeOption(state, button) {
    const input = resolveNativeInput(state, button);
    if (!input || isUnavailable(input)) return;

    state.pendingFocusKey = button.dataset.cmdKey || '';
    if (input.checked) {
      state.partialPantSelection = false;
      renderDrawer(state, { force: true });
      return;
    }

    state.partialPantSelection = false;
    input.click();
    scheduleSync(state);
    [80, 260, 700].forEach((delay) => window.setTimeout(() => syncState(state), delay));
  }

  function handleDrawerClick(state, event) {
    const close = event.target.closest('[data-cmd-close]');
    if (close) {
      event.preventDefault();
      closeDrawer(state);
      return;
    }

    const chartClose = event.target.closest('[data-cmd-size-chart-close]');
    if (chartClose) {
      event.preventDefault();
      closeSizeChart(state);
      return;
    }

    const chartOpen = event.target.closest('[data-cmd-size-chart]');
    if (chartOpen) {
      event.preventDefault();
      openSizeChart(state, chartOpen);
      return;
    }

    const finderEdit = event.target.closest('[data-cmd-finder-edit]');
    if (finderEdit) {
      event.preventDefault();
      editFinderAnswers(state);
      return;
    }

    const finderApply = event.target.closest('[data-cmd-finder-apply]');
    if (finderApply) {
      event.preventDefault();
      if (finderApply.dataset.cmdFinderApplyFailed === 'true') {
        closeSizeFinder(state, { restoreFocus: false });
      } else {
        void applyFinderRecommendation(state);
      }
      return;
    }

    const finderClose = event.target.closest('[data-cmd-finder-close]');
    if (finderClose) {
      event.preventDefault();
      closeSizeFinder(state);
      return;
    }

    const findSize = event.target.closest('[data-cmd-find-size]');
    if (findSize) {
      event.preventDefault();
      openSizeFinder(state, findSize);
      return;
    }

    const quantityMinus = event.target.closest('[data-cmd-quantity-minus]');
    if (quantityMinus) {
      event.preventDefault();
      adjustQuantity(state, -1);
      return;
    }

    const quantityPlus = event.target.closest('[data-cmd-quantity-plus]');
    if (quantityPlus) {
      event.preventDefault();
      adjustQuantity(state, 1);
      return;
    }

    const add = event.target.closest('[data-cmd-add-to-cart]');
    if (add) {
      if (add.disabled) {
        event.preventDefault();
        return;
      }
      window.setTimeout(() => closeDrawer(state, { restoreFocus: false }), 0);
      return;
    }

    const choice = event.target.closest('.cmd-choice-button[data-cmd-action]');
    if (!choice || choice.disabled) return;

    if (choice.dataset.cmdAction === 'waist') {
      const content = state.drawer.querySelector('[data-cmd-content]');
      const scrollTop = content?.scrollTop || 0;
      state.selectedWaist = choice.dataset.waist || choice.dataset.cmdKey || '';
      const groups = getGroups(state);
      const selected = groups[0]?.entries.find((entry) => entry.selected);
      state.partialPantSelection = selected?.pant?.waist !== state.selectedWaist;
      state.pendingFocusKey = choice.dataset.cmdKey || '';
      state.renderSignature = '';
      renderDrawer(state, { force: true });
      if (content) content.scrollTop = scrollTop;
      return;
    }

    if (choice.dataset.cmdAction === 'native') selectNativeOption(state, choice);
  }

  function handleDrawerQuantityInput(state, event) {
    const input = event.target.closest?.('[data-cmd-quantity-input]');
    if (!input) return;
    if (event.type === 'input' && input.value === '') return;
    setQuantity(state, input.value);
  }

  function syncState(state) {
    const variantSelects = chooseLiveVariantSelects(state.sectionId);
    if (!variantSelects) return;

    state.variantSelects = variantSelects;
    state.productFormId = variantSelects.dataset.productFormId || state.productFormId;
    state.drawer.dataset.productFormId = state.productFormId || '';
    state.trigger = getPicker(variantSelects)?.querySelector('[data-cmd-open]') || state.trigger;
    state.trigger?.setAttribute('aria-expanded', state.isOpen ? 'true' : 'false');

    applyColorSwatches(variantSelects);
    const groups = getGroups(state);
    if (isCombinedPantPicker(groups) && !state.partialPantSelection) {
      const selected = groups[0].entries.find((entry) => entry.selected);
      if (selected?.pant?.waist) state.selectedWaist = selected.pant.waist;
    }

    renderDrawer(state);
    updateSelectedDisplays(state, selectedSummary(state, groups));
    syncAddButton(state);
    syncQuantity(state);
  }

  function mountDrawer(variantSelects) {
    const sectionId = getSectionId(variantSelects);
    if (!sectionId) return null;

    let state = STATES.get(sectionId);
    const picker = getPicker(variantSelects);
    if (!picker) return state || null;

    if (!state) {
      const template = picker.querySelector('template[data-cmd-drawer-template]');
      const drawer = template?.content?.firstElementChild?.cloneNode(true);
      if (!drawer) return null;

      document.body.appendChild(drawer);
      state = {
        sectionId,
        variantSelects,
        drawer,
        trigger: picker.querySelector('[data-cmd-open]'),
        productFormId: variantSelects.dataset.productFormId || drawer.dataset.productFormId || '',
        selectedWaist: '',
        partialPantSelection: false,
        renderSignature: '',
        pendingFocusKey: '',
        lastTrigger: null,
        finderTrigger: null,
        finderRecommendation: null,
        finderApplying: false,
        finderOpen: false,
        chartTrigger: null,
        chartOpen: false,
        isOpen: false,
        syncTimer: null,
      };
      STATES.set(sectionId, state);

      drawer.addEventListener('click', (event) => handleDrawerClick(state, event));
      drawer.addEventListener('input', (event) => {
        handleDrawerQuantityInput(state, event);
        handleFinderFieldChange(state, event);
      });
      drawer.addEventListener('change', (event) => {
        handleDrawerQuantityInput(state, event);
        handleFinderFieldChange(state, event);
      });
      drawer.addEventListener('submit', (event) => handleFinderSubmit(state, event));
      drawer.addEventListener('keydown', (event) => trapFocus(state, event));
    } else {
      state.variantSelects = variantSelects;
      state.trigger = picker.querySelector('[data-cmd-open]') || state.trigger;
      state.productFormId = variantSelects.dataset.productFormId || state.productFormId;
    }

    state.drawer.dataset.productFormId = state.productFormId || '';
    state.trigger?.setAttribute('aria-expanded', state.isOpen ? 'true' : 'false');
    applyColorSwatches(variantSelects);
    syncState(state);
    return state;
  }

  function initialize(root = document) {
    applyColorSwatches(root);
    collectVariantSelects(root).forEach((variantSelects) => mountDrawer(variantSelects));
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cmd-open]');
    if (!trigger) return;

    const variantSelects = trigger.closest('variant-selects.cmd-variant-selector');
    const sectionId = getSectionId(variantSelects) || trigger.dataset.cmdSection;
    if (!sectionId) return;

    event.preventDefault();
    const state = mountDrawer(variantSelects || chooseLiveVariantSelects(sectionId)) || STATES.get(sectionId);
    if (state) openDrawer(state, trigger);
  });

  ['input', 'change'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.name !== 'quantity') return;
      STATES.forEach((state) => {
        if (getMainQuantityInput(state) === target) syncQuantity(state);
      });
    });
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    collectVariantSelects(event.target).forEach((variantSelects) => {
      const sectionId = getSectionId(variantSelects);
      const state = STATES.get(sectionId);
      if (!state) return;
      closeDrawer(state, { restoreFocus: false, immediate: true });
      state.drawer.remove();
      STATES.delete(sectionId);
    });
  });

  const observer = new MutationObserver((mutations) => {
    const affectedSections = new Set();

    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches('[data-cmd-body-drawer]') || node.closest('[data-cmd-body-drawer]')) return;
          collectVariantSelects(node).forEach((variantSelects) => {
            mountDrawer(variantSelects);
            affectedSections.add(getSectionId(variantSelects));
          });
        });

        const parentVariantSelects = mutation.target instanceof Element
          ? mutation.target.closest('variant-selects.cmd-variant-selector')
          : null;
        if (parentVariantSelects) affectedSections.add(getSectionId(parentVariantSelects));
      } else if (mutation.type === 'attributes') {
        const target = mutation.target;
        if (!(target instanceof Element) || target.closest('[data-cmd-body-drawer]')) return;
        const variantSelects = target.closest('variant-selects.cmd-variant-selector');
        if (variantSelects) affectedSections.add(getSectionId(variantSelects));
      }
    });

    affectedSections.forEach((sectionId) => {
      const state = STATES.get(sectionId);
      if (state) scheduleSync(state);
    });
  });

  function start() {
    initialize(document);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled', 'checked', 'value'],
    });
    document.documentElement.dataset.cmdSelectorVersion = VERSION;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
